import React, { useState } from 'react';

import Title from '../Title';
import DoughnutChart from '../Charts/DoughnutChart';
import ChartLabel from '../ChartLabel';
import EstimationResult from '../EstimationResult';

import './index.scss';

const Estimation = ({ responsesByDate, acceptData, declineData }) => {

  return <div className='estimation'>
    <Title title='Estimated accepts / declines:' />
    <EstimationResult responses={responsesByDate ? responsesByDate : ''} />
    <div className='estimation__wrapper'>
      <DoughnutChart accepts={acceptData} declines={declineData}/>
      <div>
        <ChartLabel number={acceptData ? acceptData[acceptData.length - 1] : '0'}
                    percentages={acceptData ? Math.round(acceptData[acceptData.length - 1] * 100 / (acceptData[acceptData.length - 1] + declineData[declineData.length - 1])) : '0'}
                    title='Accepts'
        />
        <ChartLabel number={declineData ? declineData[declineData.length - 1] : '0'}
                    percentages={declineData ? 100 - Math.round(acceptData[acceptData.length - 1] * 100 / (acceptData[acceptData.length - 1] + declineData[declineData.length - 1]))  : '0'}
                    title='Declines'
                    isColorRed
        />
      </div>
    </div>
  </div>;
};

export default Estimation;
